<template>
  <Dropdown :buttons="buttons">
    <template #trigger>
      <button
        class="flex h-7 w-7 items-center justify-between rounded-full p-1 text-2xl font-bold transition ease-in-out"
        :class="{ 'group-hover:bg-black/20': buttons.length > 0 }"
        @click.prevent=""
      >
        <Icon v-if="!isLoading" name="ellipsis-horizontal" />
        <Spinner v-else />
      </button>
    </template>
  </Dropdown>
</template>

<script setup lang="ts">
import { type DropdownItem } from './Dropdown.vue';
import Dropdown from './Dropdown.vue';
export type { DropdownItem };

defineProps<{
  buttons: DropdownItem[];
  isLoading?: boolean;
}>();
</script>
